import { render, staticRenderFns } from "./MainInputs.vue?vue&type=template&id=391d65b6&"
import script from "./MainInputs.vue?vue&type=script&lang=ts&"
export * from "./MainInputs.vue?vue&type=script&lang=ts&"
import style0 from "./MainInputs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports